export default "__VITE_ASSET__2d46fd7f__"